import type { PageSessionSnapshot } from './dtos';

/** A fresh empty page state shared by the extension and hosted sidebar. */
export function idlePageSession(): PageSessionSnapshot {
  return {
    sessionId: null,
    phase: 'idle',
    mode: 'ONCE',
    source: null,
    counts: { total: 0, filled: 0, review: 0, empty: 0 },
    reviewRows: [],
    continuous: null,
    outcome: null,
    error: null,
    warning: null
  };
}
